// extracted by mini-css-extract-plugin
export default {"link":"navLink_link__15aL8","link__active":"navLink_link__active__UpS42"};